/**
 * `/optionset/*` routes v2 calls (API_ACCESS.md §3.1), held to the snapshot by `api/routes.test.ts`.
 */
import { gated } from "../../capabilities/access";
import { defineRoutes, route } from "../route";

export const OPTIONSET = defineRoutes("optionset", {
  branchFetch: route<undefined, unknown>("GET", "/optionset/branch/fetch", gated({ modules: ["Sale", "Order", "Kiosk"] }), {
    notes: "the branch's option sets; `catalog/fetch` (P1 slice 4). v1's session bootstrap sends it too until New Order's cutover",
  }),
});
